import React, { Component, PropTypes } from 'react'
import styled from 'styled-components'
import R from 'ramda'
import Grid, { Half } from 'grid-styled'
import { translate } from 'react-i18next'
import { Metrics, Fonts } from '../../Themes'
import { validateInput, validateForm } from '../../Utils/Validations'
import { generateLetterOfIntent } from '../../sources/ContractsSource'
import { numberWithCommas } from '../../Utils'
import CardContainer from '../../components/CardContainer'
import Input from '../../components/Input'
import Button from '../../components/Button'
import Dropdown from '../../components/Dropdown'
import Calendar from '../../components/Calendar'
import Loader from '../../components/Loader'

const CustomGrid = styled(Grid)`
  padding-left: ${Metrics.margins.medium};
  padding-right: ${Metrics.margins.medium};
  button {
    margin-top: ${Metrics.margins.base};
    float: right
  }

  @media screen and (max-width: ${Metrics.breakpoints.mobile}) {
    padding: 0;
  }
`

const CustomHalf = styled(Half)`
  margin-top: ${props => (props.noPadTop ? 0 : Metrics.margins.base)};
  padding-left: ${Metrics.margins.medium};
  padding-right: ${Metrics.margins.medium};

  @media screen and (max-width: ${Metrics.breakpoints.mobile}) {
    padding: 0;
  }
`

const CustomCardContainer = styled(CardContainer)`
  height: 100%;
`

const List = styled.ul`
  padding-left: 0;
  list-style: none;
  ${Fonts.style.Text};

  li {
    margin: ${Metrics.margins.base} 0;
    padding-bottom: ${Metrics.margins.small};
    border-bottom: ${Metrics.borders.default};
  }
`

const Terms = styled.div`
  ${Fonts.style.Text};
  margin-top: ${Metrics.margins.base};
`

const Title = styled.div`
  margin-bottom: ${Metrics.margins.small};
  ${Fonts.style.Label};
`

class LetterOfIntent extends Component {
  constructor (props) {
    super(props)
    let commissions = []
    let commission = 0.25
    while (commission <= 5) {
      commissions.push(`${commission}%`)
      commission += 0.25
    }
    this.state = {
      options: commissions,
      buyerName: '',
      buyerFunction: '',
      buyerCompany: '',
      buyerStreetNr: '',
      buyerZipCode: '',
      buyerCountry: '',
      buyerCity: '',
      sellerName: '',
      sellerStreetNr: '',
      sellerZipCode: '',
      sellerCountry: '',
      sellerCity: '',
      property: '',
      price: '',
      sellerBank: '',
      commission: '',
      authorization: '',
      validityDate: '',
      generating: false,
      errors: {
        buyerFunction: '',
        buyerName: '',
        buyerCompany: '',
        buyerStreetNr: '',
        buyerZipCode: '',
        buyerCountry: '',
        buyerCity: '',
        sellerName: '',
        sellerStreetNr: '',
        sellerZipCode: '',
        sellerCountry: '',
        sellerCity: '',
        property: '',
        price: '',
        sellerBank: '',
        commission: '',
        authorization: '',
        validityDate: ''
      }
    }
    this.handleChange = this.handleChange.bind(this)
    this.downloadFile = this.downloadFile.bind(this)
    this.handleValidate = this.handleValidate.bind(this)
    this.handleSelect = this.handleSelect.bind(this)
  }

  handleChange (event, key) {
    const state = R.clone(this.state)
    state[key] = event.target.value
    this.setState(state)
  }

  downloadFile () {
    const { errors } = R.clone(this.state.errors)
    let validation = validateForm(this.state, errors)
    if (validation.valid) {
      this.setState({ generating: true }, () => {
        generateLetterOfIntent({
          sellerName: this.state.sellerName,
          sellerZipCode: this.state.sellerZipCode,
          sellerAddress: this.state.sellerStreetNr,
          sellerCountry: this.state.sellerCountry,
          sellerCity: this.state.sellerCity,
          price: `${numberWithCommas(parseInt(this.state.price, 10))}€`,
          authorization: this.state.authorization,
          propertyName: this.state.property,
          name: this.state.buyerName,
          companyName: this.state.buyerCompany,
          country: this.state.buyerCountry,
          city: this.state.buyerCity,
          function: this.state.buyerFunction,
          address: this.state.buyerStreetNr,
          zipCode: this.state.buyerZipCode,
          commission: this.state.commission,
          bank: this.state.sellerBank,
          validityDate: this.state.validityDate
        })
          .then(response => {
            document.location = response.data.url
            this.setState({ generating: false })
          })
          .catch(console.error)
      })
    } else {
      this.setState({ errors: validation.errors })
    }
  }

  handleValidate (name, value, errors) {
    let newErrors = validateInput(name, value, errors)
    this.setState({ errors: newErrors })
  }

  handleSelect (el, key) {
    const state = R.clone(this.state)
    state[key] = el.toString()
    this.setState(state)
  }

  render () {
    const { t } = this.props
    const { errors } = R.clone(this.state)
    let sellerKeys = [
      {
        key: 'property',
        label: t('Property name'),
        placeholder: t('Property Name')
      },
      {
        key: 'sellerName',
        label: t('Seller Name or Company Name'),
        placeholder: t('Name of the seller')
      },
      {
        key: 'sellerStreetNr',
        label: t('Seller Street Number'),
        placeholder: t('Street Number')
      },
      {
        key: 'sellerZipCode',
        label: t('Seller Zip Code'),
        placeholder: t('Zip Code')
      },
      {
        key: 'sellerCountry',
        label: t('Seller Country'),
        placeholder: t('Country')
      },
      { key: 'sellerCity', label: t(`Seller's City`), placeholder: t('City') },
      { key: 'sellerBank', label: t(`Seller's Bank`), placeholder: t('Bank') },
      { key: 'price', label: t('Price'), placeholder: t('Price Value') }
    ]

    let buyerKeys = [
      { key: 'buyerName', label: t('Name '), placeholder: t('Name') },
      {
        key: 'buyerCompany',
        label: t('Buyer Company Name'),
        placeholder: t('Company Name')
      },
      {
        key: 'buyerFunction',
        label: t('Buyer Function'),
        placeholder: t('Function')
      },
      {
        key: 'buyerStreetNr',
        label: t('Buyer Street Number'),
        placeholder: t('Street Number')
      },
      {
        key: 'buyerZipCode',
        label: t('Buyer Zip Code'),
        placeholder: t('Zip Code')
      },
      {
        key: 'buyerCountry',
        label: t('Buyer Country'),
        placeholder: t('Country')
      },
      { key: 'buyerCity', label: t(`Buyer's City`), placeholder: t('City') }
    ]

    let authorizations = [ t('Seller'), t(`Seller's Bank`) ]

    return (
      <CustomCardContainer title={t('Letter of Intent')}>
        <Loader visible={this.state.generating} />
        {sellerKeys.map((el, index) => {
          return (
            <CustomHalf
              key={el.key}
              noPadLeft={index % 2 === 0}
              noPadRight={index % 2 === 1}>
              <Input
                placeholder={el.placeholder}
                name={el.key}
                required
                title={el.label}
                value={this.state[el.key]}
                handleChange={event => this.handleChange(event, el.key)}
                error={errors[el.key]}
                handleBlur={event =>
                  this.handleValidate(el.key, this.state[el.key], errors)}
              />
            </CustomHalf>
          )
        })}

        <CustomHalf key={'authorization'} noPadRight>
          <Title>{t('Authorization')}</Title>
          <Dropdown
            placeholder={t('Select the authorization method')}
            options={authorizations}
            selectedOption={this.state.authorization}
            handleSelect={el => this.handleSelect(el, 'authorization')}
            error={errors.authorization}
            handleBlur={event =>
              this.handleValidate(
                'authorization',
                this.state.authorization,
                errors
              )}
            name={'authorization'}
            required
          />
        </CustomHalf>

        <CustomHalf key={'commission'} noPadRight>
          <Title>{t('Commission')}</Title>
          <Dropdown
            placeholder={t('Select commission value')}
            options={this.state.options}
            selectedOption={this.state.commission}
            handleSelect={el => this.handleSelect(el, 'commission')}
            error={errors.commission}
            handleBlur={event =>
              this.handleValidate('commission', this.state.commission, errors)}
            name={'commission'}
            required
          />
        </CustomHalf>

        <CustomHalf key={'calendar'}>
          <Calendar
            id={'validityDate'}
            error={errors.validityDate}
            title={t('Validity Date')}
            value={this.state.validityDate}
            handleSelect={value => this.handleSelect(value, 'validityDate')}
            handleBlur={event =>
              this.handleValidate(
                'validityDate',
                this.state.validityDate,
                errors
              )}
          />
        </CustomHalf>

        <CustomGrid>
          <Terms>
            The Buyer intends to purchase the
            {this.state.property ? (
              ' '.concat(this.state.property)
            ) : (
              <b> {t('PROPERTY')} </b>
            )}
            (the "Asset"), including all of the intellectual property, movable
            property, real property, the customer- and supplier relationships
            and all contracts and assets which are related to its business (the
            "Business") and which are required to operate the Business as it is
            operated as of the signing of this Letter of Intent. Now therefore,
            the Parties wish to set forth in this Letter of Intent the main
            terms of the Transaction as follows:
            <List>
              <li>
                <Title>Negotiation of Sale and Purchase</Title>
                <div>
                  The Parties shall negotiate in good faith the conclusion of a
                  purchase agreement regarding the Transaction (the "Purchase
                  Agreement")
                </div>
              </li>
              <li>
                <Title>Purchase Price</Title>
                <div>
                  The purchase price (the "Purchase Price") shall be
                  {this.state.price ? (
                    ' '.concat(this.state.price).concat('€ ')
                  ) : (
                    <b> {t('PRICE')}</b>
                  )}, including a
                  {this.state.commission ? (
                    ' '.concat(this.state.commission).concat(' ')
                  ) : (
                    <b> {t('COMMISSION')} </b>
                  )}
                  buyer commission fee in favor of HvB Investment AG’s
                  designated bank account, subject to any material negative
                  findings in the course of the due diligence. We hereby
                  authorize
                  {this.state.sellerBank ? (
                    ' '.concat(this.state.sellerBank).concat(' ')
                  ) : (
                    <b> {t('BANK')} </b>
                  )}
                  to initiate the transaction of the
                  {this.state.commission ? (
                    ' '.concat(this.state.commission).concat(' ')
                  ) : (
                    <b> {t('COMMISSION')} </b>
                  )}
                  commission fee after a successful closing.
                </div>
              </li>
              <li>
                <Title>Benefits and Risks</Title>
                <div>
                  The benefits and risks of the Business shall transfer upon
                  Closing.
                </div>
              </li>
              <li>
                <Title>Representations and Warranties</Title>
                <div>
                  The Purchase Agreement shall contain customary representations
                  and warranties, guarantees and covenants from the Seller, as
                  are usual for transactions of this nature. A liability cap
                  shall be discussed and agreed between the Parties during the
                  due diligence. The statute of limitations for any claims under
                  the Purchase Agreement shall be two (2) years. In order to
                  secure any claims the Buyer may have following a breach of
                  representations and warranties, guarantees or covenants, the
                  Purchase Agreement may provide for an escrow amount to be
                  funded out of the purchase price.
                </div>
              </li>
              <li>
                <Title>Transfer of Agreements</Title>
                <div>
                  In general, contracts may only be transferred with the
                  approval of the counterparty. Should a contractual
                  counterparty reject the approval, the Seller shall terminate
                  such contract as soon as possible. Until termination of the
                  contract, the Parties shall put each other into the same
                  position as if the contract were transferred.
                </div>
              </li>
              <li>
                <Title>Conditions Precedents</Title>
                <div>
                  The Purchase Agreement shall be subject to the approval of the
                  board of directors of Buyer, the absence of a material adverse
                  change and, to the extent necessary, any other approval
                  required from authorities.
                </div>
              </li>
              <li>
                <Title>Actions between Signing and Closing</Title>
                <div>
                  Between signing and closing, the Seller shall operate the
                  Business in the ordinary course of business, provide access
                  and transfer all necessary data to the Buyer and obtain all
                  consents to transfer material contracts.
                </div>
              </li>
              <li>
                <Title>Due diligence</Title>
                <div>
                  Upon execution of this Letter of Intent, the Parties shall
                  start with the preparations for a comprehensive due diligence
                  review of the Business, such due diligence to examine and
                  cover, but not be limited to, financial, commercial, legal,
                  tax, environmental, and insurance aspects, as deemed
                  appropriate by Buyer. Upon delivery of the relevant due
                  diligence request lists by Buyer, Seller shall prepare an
                  appropriate data room providing for all the relevant
                  information and documentation that can be reasonably expected
                  during a structured due diligence process and/or which was
                  specifically requested by Buyer (the “Data Room”). Buyer and
                  its advisors shall be granted reasonable access to the Seller
                  and to the Data Room as well as to the Seller’s external
                  accountant and the Seller’s books and records, in order to
                  allow Buyer to conduct the above described due diligence
                  review within 4 weeks as of the date hereof, provided,
                  however, that such due diligence investigation shall permit
                  the Seller the uninterrupted continuation of its activities.
                </div>
              </li>
              <li>
                <Title>Exclusivity</Title>
                <div>
                  The Parties agree that during the Exclusivity Period (as
                  defined below), conversations and negotiations regarding the
                  transactions are only conducted with the other Party. The
                  Parties agree that during the Exclusivity Period, neither
                  Seller nor any representatives of the foregoing shall,
                  directly or indirectly, solicit or enter into discussions or
                  negotiations with, or provide any information to, or entertain
                  or accept any offer of any other person concerning the
                  potential sale of the Asset or the potential sale of any or
                  all of the Business with any person other than Buyer and
                  Buyer. The "Exclusivity Period" shall mean the period
                  commencing on the date hereof and ending on the earlier of:
                  (i) the date on which Seller and Buyer mutually agree in
                  writing that the purchase contemplated herein cannot be
                  concluded, or (ii)
                  {this.state.validityDate ? (
                    ' '.concat(this.state.validityDate)
                  ) : (
                    <b> {t('VALIDITY DATE')}</b>
                  )}.
                </div>
              </li>
              <li>
                <Title>Confidentiality</Title>
                <div>
                  Each of the Parties hereto and all their representatives shall
                  maintain the confidentiality of all information received from
                  the other in connection with the transaction contemplated
                  herein, except (i) information in the public domain or
                  independently received from a third party with a right to
                  disclose such information or (ii) to the extent that
                  disclosure is required by law. No public announcement of this
                  LOI or the Transaction will be made, nor will any announcement
                  be made to the employees, partners, suppliers or any other
                  party related to the Business, unless such announcement has
                  the prior written approval of the Parties Each of the Parties
                  shall also abstain from disclosing any aspect of their
                  negotiations or the existence of this Letter of Intent or the
                  transactions contemplated herein to any other person, except
                  for persons being involved in the transaction. If the
                  transaction contemplated herein is not concluded for any
                  reason, all information and material received by the other
                  Party hereto and its representatives shall be returned
                  promptly to the party having provided such information.
                </div>
              </li>
              <li>
                <Title>Expenses</Title>
                <div>
                  The Parties shall each be responsible for its own fees, costs,
                  and expenses incurred in connection with the Transaction.
                </div>
              </li>
              <li>
                <Title>Binding Provisions</Title>
                <div>
                  The provisions of this Letter of Intent shall not be legally
                  binding and enforceable with the exception of sections 9
                  (Exclusivity), 10 (Confidentiality), 11 (Expenses), 12
                  (Binding Provisions), 13 (Term), 14 (Miscellaneous) and 15
                  (Governing Law /Arbitration). In particular, the Parties
                  recognise that this Letter of Intent does neither constitute
                  an offer to purchase nor a consent to sell the Business of the
                  Seller, nor does it create any legally enforceable rights that
                  would compel any of the Parties to proceed further with the
                  negotiations.
                </div>
              </li>
              <li>
                <Title>Term</Title>
                <div>
                  This Letter of Intent shall expire upon the earlier of (a) the
                  execution of the Purchase Agreement or (b)
                  {this.state.validityDate ? (
                    ' '.concat(this.state.validityDate)
                  ) : (
                    <b> {t('VALIDITY DATE')}</b>
                  )}, unless extended by agreement of the Parties.
                </div>
              </li>
              <li>
                <Title>Miscellaneous</Title>
                <div>
                  This Letter of Intent or any rights thereof may not be
                  transferred, assigned, pledged or hypothecated by either Party
                  to a third party, unless previously agreed to in writing by
                  the other Party. This Letter of Intent may be amended or
                  terminated only by an instrument in writing signed by the
                  Parties. Should any of the provisions of this Letter of Intent
                  prove to be or become void or unenforceable, such provision
                  shall be deemed to be replaced by another clause the substance
                  whereof shall be as close as possible to the economic purpose
                  of the clause which is void or unenforceable. The validity of
                  the other clauses of this Letter of Intent shall not be
                  affected thereby. The same rule shall apply to a supplementary
                  interpretation of this Letter of Intent. All other documents
                  relating the transactions will be drafted in English.
                </div>
              </li>
              <li>
                <Title>Governing Law / Arbitration</Title>
                <div>
                  This Letter of Intent shall be governed by and construed in
                  accordance with the laws of Switzerland. All disputes arising
                  out of or in connection with the present contract shall be
                  finally settled under the Rules of Arbitration of the
                  International Chamber of Commerce by one or more arbitrators
                  appointed in accordance with the said Rules. The number of
                  arbitrators shall be one. The arbitral proceedings shall be
                  conducted in English. The seat of arbitration shall be Zurich,
                  Switzerland.
                </div>
              </li>
            </List>
          </Terms>
        </CustomGrid>

        {buyerKeys.map((el, index) => {
          return (
            <CustomHalf
              key={el.key}
              noPadLeft={index % 2 === 0}
              noPadRight={index % 2 === 1}>
              <Input
                placeholder={el.placeholder}
                name={el.key}
                required
                title={el.label}
                value={this.state[el.key]}
                handleChange={event => this.handleChange(event, el.key)}
                error={errors[el.key]}
                handleBlur={event =>
                  this.handleValidate(el.key, this.state[el.key], errors)}
              />
            </CustomHalf>
          )
        })}

        <CustomGrid>
          <Button label={t('Download')} onClick={this.downloadFile} />
        </CustomGrid>
      </CustomCardContainer>
    )
  }
}

LetterOfIntent.propTypes = {
  t: PropTypes.func,
  router: PropTypes.object,
  children: PropTypes.node
}

export default translate([ 'common', 'forms', 'admin' ], { wait: true })(
  LetterOfIntent
)



// WEBPACK FOOTER //
// ./src/pages/Agreements/LetterOfIntent.js